// extracted by mini-css-extract-plugin
module.exports = {"container":"Main-container-2PETi"};